(() => {
  const showPassword = document.querySelector(".show-password-login");
  const hidePasswordIcon = document.querySelector(".hidepassword-icon");
  const showPasswordIcon = document.querySelector(".showpassword-icon");

  if (showPassword) {
    showPassword.addEventListener("click", function () {
      const password = document.querySelector('input[name="customer[password]"]');
      if (!password) return;

      if (password.type === "password") {
        password.type = "text";
        showPasswordIcon?.classList.add("js-hide");
        hidePasswordIcon?.classList.remove("js-hide");
      } else {
        password.type = "password";
        showPasswordIcon?.classList.remove("js-hide");
        hidePasswordIcon?.classList.add("js-hide");
      }
    });
  }

  const modal = document.querySelector(".reset-modal");
  const button = document.querySelector(".js-reset-password");

  if (modal && button) {
    button.addEventListener("click", function () {
      modal.classList.remove("js-modal-hidden");
    });
  }

  if (modal) {
    const close = document.querySelector(".js-modal-close");
    close?.addEventListener("click", function () {
      modal.classList.add("js-modal-hidden");
    });
  }
})();
